/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CustomerResponse from './CustomerResponse';
import SensorConsumptionResponse from './SensorConsumptionResponse';
import SensorHistory from './SensorHistory';
import SensorResponse from './SensorResponse';
import TankResponse from './TankResponse';

/**
* The GetCustomerTankResponse model module.
* @module model/GetCustomerTankResponse
* @version 2020-12-7
*/
export default class GetCustomerTankResponse {
    /**
    * Constructs a new <code>GetCustomerTankResponse</code>.
    * 顧客タンク取得レスポンス
    * @alias module:model/GetCustomerTankResponse
    * @class
    * @param customer {module:model/CustomerResponse} 
    * @param tank {module:model/TankResponse} 
    * @param sensorHistories {Array.<module:model/SensorHistory>} センサーの履歴
    * @param result {module:model/GetCustomerTankResponse.ResultEnum} 
    */

    constructor(customer, tank, sensorHistories, result) {
        
        
        this['customer'] = customer;
        this['tank'] = tank;
        this['sensorHistories'] = sensorHistories;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>GetCustomerTankResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/GetCustomerTankResponse} obj Optional instance to populate.
    * @return {module:model/GetCustomerTankResponse} The populated <code>GetCustomerTankResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetCustomerTankResponse();
                        
            
            if (data.hasOwnProperty('customer')) {
                obj['customer'] = CustomerResponse.constructFromObject(data['customer']);
            }
            if (data.hasOwnProperty('tank')) {
                obj['tank'] = TankResponse.constructFromObject(data['tank']);
            }
            if (data.hasOwnProperty('sensor')) {
                obj['sensor'] = SensorResponse.constructFromObject(data['sensor']);
            }
            if (data.hasOwnProperty('record')) {
                obj['record'] = SensorConsumptionResponse.constructFromObject(data['record']);
            }
            if (data.hasOwnProperty('sensorHistories')) {
                obj['sensorHistories'] = ApiClient.convertToType(data['sensorHistories'], [SensorHistory]);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {module:model/CustomerResponse} customer
    */
    'customer' = undefined;
    /**
    * @member {module:model/TankResponse} tank
    */
    'tank' = undefined;
    /**
    * @member {module:model/SensorResponse} sensor
    */
    'sensor' = undefined;
    /**
    * @member {module:model/SensorConsumptionResponse} record
    */
    'record' = undefined;
    /**
    * センサーの履歴
    * @member {Array.<module:model/SensorHistory>} sensorHistories
    */
    'sensorHistories' = undefined;
    /**
    * @member {module:model/GetCustomerTankResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
